//GeneratorFlag:[NoChange]
import { ENUMS, BaseEntity } from '@/core/data'
export default class DeliveryDateType extends BaseEntity
{
	constructor(arg)
	{
		super();
		this.prepair(arg);
	}
	name = 'deliveryDateType';
	schema = ENUMS.SCHEMA_TYPE.BASIS;
	resourceKey = 'store.deliveryDateType';
	props = {
		deliveryDateTypeId: {
			primarykey: true,
			name: 'deliveryDateTypeId',
			resourceKey: 'store.deliveryDateTypeDeliveryDateTypeId',
			type: ENUMS.PROP_TYPE.BYTE,
			display: {
				isVisible: true, 
				displayType: ENUMS.DISPLAY_TYPE.NUMBER,
				direction: ENUMS.DIRECTION_TYPE.LTR,
			},
			setConfig: { 
				inputType: ENUMS.INPUT_TYPE.NUMBER,
				canUseInForm: true,  
				canUseInExcel: false,  
				isUnicode: false,
				isUnique: false,
				patterns: [],
			},
			errors: [],
			value: null
		},
	};
}